<template>
	<span class="animated-logo-title" ref="animated-logo" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/animated-title.json'

export default {
	name: 'AnimatedTitle',

	data() {
		return {
			animatedLogo: null
		}
	},

	mounted() {
		this.animatedLogo = lottie.loadAnimation({
			container: this.$refs['animated-logo'],
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData
		})
	},

	beforeDestroy() {
		this.animatedLogo.destroy()
	}
}
</script>

<style lang="scss">
.animated-logo-title {
	display: block;
	width: 172px;
	height: 101px;
	margin: auto;

	svg {
		width: 100%;
		height: 100%;
	}
}
</style>
